var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"border rounded bg-white status-badge",class:("text-" + _vm.variant + " border-" + _vm.variant)},[_c('span',{staticClass:"font-weight-bold"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }